<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>设备版本</el-breadcrumb-item>
          <el-breadcrumb-item>版本下发</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="account">
            <div class="tab-content">
              <el-form :label-position="labelPosition" label-width="120px">
                <el-form-item label="版本系统">
                  {{ model.versionType == 1 ? "Windows" : "Android" }}
                </el-form-item>
                <el-form-item label="版本名称">
                  {{ model.versionName }}
                </el-form-item>
                <el-form-item label="版本号">
                  {{ model.versionNo }}
                </el-form-item>

                <el-form-item label="下发设备">
                  <el-select
                    v-model="cabinetCode"
                    multiple
                    filterable
                    placeholder="请选择设备"
                  >
                    <el-option
                      v-for="item in deviceList"
                      :key="item.cabinetCode"
                      :label="
                        item.cabinetCode + ' ( ' + item.companyName + ' ) '
                      "
                      :value="item.cabinetCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="描述说明">
                  <el-input
                    type="textarea"
                    v-model="model.remark"
                    readonly
                    style="width: 200px"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm()">版本下发</el-button>
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax, baseApi } from "../../js/axios.config";
export default {
  data() {
    return {
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      fileUrls: "",
      model: {
        id: "",
        versionType: 1,
        versionNo: "",
        versionName: "",
        fileUrl: "",
        md5: "",
        remark: "",
      },
      deviceList: [],
      cabinetCode: [],
    };
  },
  mounted() {
    this.initData();
    const _this = this;
    const type = localStorage.getItem("fx_login_companyType");
    let url = "";
    if (type == 0) {
      url = "/cabinet/cabinet/search";
    } else {
      url =
        "/cabinet/cabinet/search?companyId=" +
        localStorage.getItem("fx_login_companyId");
    }
    // 获取公司设备
    AxiosAjax({
      url: url,
      success: function (res) {
        _this.deviceList = res.data.data;
      },
    });
  },
  methods: {
    //初始化数据
    initData: function () {
      let _this = this; //当前页面
      let id = _this.$route.query.id || ""; //获取ID
      AxiosAjax({
        url: "/cabinet/sysVersionControl/" + id,
        loading: true,
        success: function (res) {
          _this.model.id = res.data.data.id;
          _this.model.versionType = res.data.data.versionType;
          _this.model.versionNo = res.data.data.versionNo;
          _this.model.versionName = res.data.data.versionName;
          _this.model.md5 = res.data.data.md5;
          _this.model.remark = res.data.data.remark;
          _this.model.fileUrl = baseApi + "/cabinet" + res.data.data.fileUrl;
          _this.fileUrls = baseApi + "/cabinet" + res.data.data.fileUrl;

          //赋值给model
        },
      });
    },
    submitForm: function () {
      let _this = this; //当前页面
      //提交表单,Id大于0则修改，否则添加
      let params = {
        versionNameLike: _this.model.versionName,
        versionType: _this.model.versionType,
        cabinetCodes: _this.cabinetCode,
        softVer: _this.model.versionNo,
        downUrl: _this.model.fileUrl,
        md5: _this.model.md5,
        force: 1,
      };
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/batchUpdateSoft",
        data: params,
        loading: true,
        successMsg: "版本下发成功",
        success: function (res) {
          //可跳转加列表页
          _this.$router.push({ name: "VersioningList" });
        },
      });
    },
    resetForm() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
.el-form-item /deep/ .el-form-item__content {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Versioning/VersioningLook.vue